/** Scope chain of the Contract validation & compliance domain. Values are the API names. */
export enum ScopeLevel {
  AGENCY = 'Agency',
  JOINT_COMMISSION = 'JointCommission',
  COMPANY = 'Company',
  API_USER = 'ApiUser',
}
